export default __webpack_public_path__ + "static/media/doctor-5.9f1cddb9.jpg";